import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import MemberAvatar from "@/components/common/MemberAvatar";
import ProgramBadge from "@/components/sponsors/ProgramBadge";

/**
 * Right-rail "Favorites" card (first five saved sponsors).
 *
 * Extracted verbatim from src/pages/Dashboard.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged.
 */
export default function FavoritesCard({ favorites }) {
  return (
    <section className="sm-card p-6 bg-white">
      <div className="flex items-center gap-2">
        <Heart className="w-5 h-5 text-[#D07A4A]" />
        <h2 className="font-display text-xl font-bold text-[#1F2A2E]">Favorites</h2>
      </div>
      {favorites.length === 0 ? (
        <p className="mt-3 text-sm text-[#4B5A60]">
          No saved sponsors yet. Tap the heart on a profile to save it here.
        </p>
      ) : (
        <ul className="mt-3 space-y-2">
          {favorites.slice(0, 5).map((f) => (
            <li key={f.user_id}>
              <Link
                to={`/sponsors/${f.user_id}`}
                className="flex items-center gap-3 py-1.5 hover:opacity-80"
              >
                <MemberAvatar user={f.user} size={34} />
                <span className="text-sm font-semibold text-[#1F2A2E]">{f.user?.display_name}</span>
                <span className="ml-auto">
                  <ProgramBadge program={f.recovery_program} />
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
      <Link to="/favorites" className="mt-3 inline-block text-sm font-semibold text-[#1F6F78]">
        See all favorites
      </Link>
    </section>
  );
}
